<div class="btn-group" ngbDropdown>
    <button appButtonIcon color="gray" ngbDropdownToggle data-test="notification-settings-toggle">
        <svg-icon [src]="svgDefaultSrc + 'Settings.svg'"></svg-icon>
    </button>
    <div class="dropdown-menu" ngbDropdownMenu>
        <button
            (click)="openNotificationSettingsModal()"
            ngbDropdownItem
            data-test="notification-settings-notifications">
            {{ 'layout.topbar.links.settings.notifications' | translate }}
        </button>
    </div>
</div>
